module.exports = __webpack_public_path__ + "static/media/66.993c1726.jpg";